__webpack_require__.p = "https://tastermpoint-mfe-account-cdt.maersk.io/mfe/account/";